import { InputStyled } from '@components/Common/SharedStyles';
import React from 'react';
import styled from 'styled-components';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  height?: string;
}

interface StyledTextAreaProps {
  $height?: string;
}

const TextAreaStyled = styled.textarea<StyledTextAreaProps>`
  ${InputStyled}
  height: ${props => props.$height || '150px'};
`;

export const TextArea: React.FC<TextAreaProps> = ({ height, ...rest }) => {
  return <TextAreaStyled $height={height} id={rest.name} {...rest} />;
};

export default TextArea;
